export default {"src":"/_next/static/media/badass-badge-censored-dark.5668f99b.svg","height":56,"width":170,"blurWidth":0,"blurHeight":0};